/**
 *
 * TCFModal
 *
 */

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import { Link, useHistory } from 'react-router-dom';

// styles
import './style.scss';

// antd component
import { Modal, Button } from 'antd';

// icons
import CustomIcons from 'components/CustomIcons';

// components
import ErrorBoundary from 'engine/ErrorBoundary';

function TCFModal({
  open,
  loading,
  confirmLoading,
  // states
  title,
  cancelName,
  submitName,
  closable,
  // actions
  setOpen,
  onOk,
  onClose,
  onCancel,
  // default props
  className,
  wrapClassName,
  children,
  ...rest
}) {
  const childClassNames = classNames('tcf-modal', className);

  const onCloseHandler = useCallback(() => {
    !!setOpen && setOpen(false);
    !!onClose && onClose();
  }, [onClose, onClose]);
  
  const onCancelHandler = useCallback(() => {
    !!setOpen && setOpen(false);
    !!onCancel && onCancel();
  }, [onCancel, setOpen]);

  const onOkHandler = useCallback(() => {
    !!onOk && onOk();
    // !!setOpen && setOpen(false);
  }, [onOk, setOpen]);

  return (
    <ErrorBoundary>
      <Modal
        {...rest}
        wrapClassName={classNames("tcf-modal-wrapper", wrapClassName)}
        className={childClassNames}
        title={title}
        open={open}
        onOk={onOkHandler}
        confirmLoading={confirmLoading}
        onCancel={onCloseHandler}
        closable={closable}
        footer={[
          !!onCancel && (
            <Button
              key="back"
              className="ant-btn-cancel"
              type="default"
              onClick={onCancelHandler}
            >
              {cancelName}
            </Button>
          ),
          !!onOk && (
            <Button
              key="submit"
              className="ant-btn-submit"
              type="default"
              loading={loading}
              onClick={onOkHandler}
            >
              {submitName}
            </Button>
          ),
        ]}
      >
        {children}
      </Modal>
    </ErrorBoundary>
  );
}

TCFModal.defaultProps = {
  title: 'Title',
  cancelName: 'Annuler',
  submitName: 'Ajouter',
  closable: false
};
TCFModal.propTypes = {};

export default TCFModal;
